/* @flow */
import React, { Component, useState } from "react";
import { Form, Message } from "semantic-ui-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addNote, getCreateError } from "../../redux/modules/note";
import { cmdEnter } from "../../helpers/cmd-enter";
import { t } from "../../constant/translations";

type Props = {
  entity: Object,
  entityType: string,
  addNote: Function,
  error?: Object,
  onSubmit: Function,
};

export const NoteForm = (props: Props) => {
  const [state, setState] = useState({});

  const onSubmit = (event) => {
    event.preventDefault();
    props.addNote(props.entity.id, props.entityType, state.content);
    props.onSubmit && props.onSubmit();
  };

  const { error } = props;
  return (
    <Form reply onSubmit={onSubmit} error={error !== null}>
      <Form.Field>
        <Form.TextArea
          name="content"
          required
          label={t("note.new_note")}
          onChange={(event) =>
            setState({ ...state, content: event.target.value })
          }
          placeholder={t("note.content")}
          onKeyDown={cmdEnter(onSubmit)}
        />
      </Form.Field>
      <Message
        error={true}
        header={t("note.error")}
        content={error ? error.message : error}
      />
      <Form.Button type="submit" primary disabled={!state.content}>
        {t("note.add")}
      </Form.Button>
    </Form>
  );
};

function stateToProps(state) {
  return { error: getCreateError(state) };
}

function dispatchToProps(dispatch) {
  return bindActionCreators({ addNote }, dispatch);
}

export default connect(stateToProps, dispatchToProps)(NoteForm);
